<template>
  <ui-table
    url="tasks/bpDealer/page"
    :search="query"
    @onReset="onReset"
    @handleSelectionChange="handleSelectionChange"
  >
    <template #search-content>
      <el-form
              ref="ruleFormRef"
              :model="query"
              label-width="120px"
              :inline="true"
              class="demo-form-inline"
      >
        <el-form-item label="费用类型" prop="dealerStatus">
          <el-select v-model="query.dealerStatus" placeholder="请选择经销商状态" clearable>
            <el-option v-for="(item,index) in dealerStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="费用分类" prop="dealerStatus">
          <el-select v-model="query.dealerStatus" placeholder="请选择经销商状态" clearable>
            <el-option v-for="(item,index) in dealerStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="流程状态" prop="dealerStatus">
          <el-select v-model="query.dealerStatus" placeholder="请选择经销商状态" clearable>
            <el-option v-for="(item,index) in dealerStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="退款金额" prop="dealerName">
          <el-input v-model="query.dealerName" placeholder="请输入经销商名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="申请人" prop="dealerName">
          <el-input v-model="query.dealerName" placeholder="请输入经销商名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
                  v-model="query.endTime"
                  type="date"
                  clearable
                  placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否重复" prop="dealerStatus">
          <el-select v-model="query.dealerStatus" placeholder="请选择经销商状态" clearable>
            <el-option v-for="(item,index) in dealerStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="支付宝账户" prop="area">
          <el-input v-model="query.area" placeholder="请输入战区" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单来源" prop="area">
          <el-select v-model="query.dealerStatus" placeholder="请选择经销商状态" clearable>
            <el-option v-for="(item,index) in dealerStatusList" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车架号" prop="area">
          <el-input v-model="query.area" placeholder="请输入战区" clearable></el-input>
        </el-form-item>
        <el-form-item label="订单号" prop="area">
          <el-input v-model="query.uphone" placeholder="请输入员工手机号/手机号" clearable></el-input>
        </el-form-item>
      </el-form>
    </template>
    <template #btn>
      <el-button @click="exportFile">导出</el-button>
    </template>
    <template #column>
      <el-table-column prop="dealerCode" label="经销商编码" />
      <el-table-column prop="dealerName" label="经销商名称" />
      <el-table-column prop="contactsName" label="经销商联系人姓名" />
      <el-table-column prop="contactNumber" label="经销商联系人电话" />
      <el-table-column prop="status" label="经销商状态">
        <template #default="scope">
          <span v-if="scope.row.status == 0">正常</span>
          <span v-if="scope.row.status == 1">撤户</span>
        </template>
      </el-table-column>
      <el-table-column label="下属门店">
        <template #default="scope">
          <el-button type="text" @click="viewMoreStore(scope.row)">查看更多</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="areaName" label="战区" />
      <el-table-column label="操作">
        <template #default="scope">
          <el-button type="text" @click="empowerUserDialog(scope.row)">查看详情</el-button>
        </template>
      </el-table-column>
    </template>
  </ui-table>
  <el-dialog v-model="outerVisible" :append-to-body="false" title="绑定赋能人员" width="400px">
    <el-form label-width="125px">
      <el-form-item label="赋能人员手机号：">
        <el-input v-model="form.phone" type="textarea" placeholder="请输入赋能人员手机号"></el-input>
      </el-form-item>
      <div style="color:red">若有多个赋能人员请用,隔开</div>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="clearForm">重置</el-button>
        <el-button type="primary" @click="save">保存</el-button>
      </div>
    </template>
  </el-dialog>
  <el-dialog v-model="storeVisiable" :append-to-body="false" title="管辖门店" width="800px">
    <el-table :data="storeData" border :header-cell-style="setHeaderStyle">
      <el-table-column type="index" label="序号" width="60"/>
      <el-table-column prop="storeCode" label="门店编码" />
      <el-table-column prop="storeName" label="门店名称" />
      <!-- <el-table-column prop="storeGrade" label="门店等级" /> -->
    </el-table>
  </el-dialog>
  <el-dialog v-model="empowerUserDialogVisiable" title="赋能人员" width="600px">
    <el-table :data="userData" border :header-cell-style="setHeaderStyle">
      <el-table-column type="index" label="序号" width="60"/>
      <el-table-column prop="userName" label="姓名" />
      <el-table-column prop="userPhone" label="手机号" />
      <el-table-column label="操作">
        <template #default="scope">
          <el-popconfirm title="是否确定解绑?" @confirm="unbind(scope.row)">
            <template #reference>
              <el-button type="text" class="red-btn">解绑</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
  import { defineComponent, onMounted, reactive,ref } from 'vue';
  // import {getBpDealer,bpDealerBindUser,bpDealerClearBind,exportBpDealerTemplate,importBpDealer,exportDealerListByBpDealerVo,getOneDealerRecord,getAllbpDealerBindRecord,getBingUsers,unBindBpDealer,getBpStores,exportDealerBindRecordListByBpDealerVo} from '@/api/dealer'
  import { ElMessage } from 'element-plus/lib/components';
  import {downloadFile} from '@/utils/file'
  import uploadFileDialog from '@/components/uploadFileDialog/index.vue'

  export default defineComponent({
    name:'dealerManager',
    components:{
      uploadFileDialog
    },
    setup(){
      let data = ref([])
      let query = reactive({
        dealerCode:'',
        dealerName:'',
        dealerPhone:'',
        dealerStatus:'',
        area:'',
        uphone:'',
        username:'',
        endTime:''
      })
      let allRecordQuery = reactive({
        dealerCode:'',
        dealerName:'',
        createBy:'',
        userName:'',
        userPhone:'',
        operationStatus:'',
        page:1,
        pageSize:10
      })
      const dealerStatusList = [
        {value:0,label:'正常'},
        {value:1,label:'撤户'},
      ]
      let outerVisible = ref(false)
      let dialogTitle = ref('新增')
      let importloadLoading = ref(false)
      let oneRecordVisiable = ref(false)
      let allRecordVisiable = ref(false)
      let storeVisiable = ref(false)
      let storeData = ref([])
      let oneRecordData = ref([])
      let allRecordData = ref([])
      let currentDealerId
      let currentId
      let currentRow = {}
      let isEdit = false
      let delIds = ref([])
      let total = ref(0)
      let empowerUserDialogVisiable = ref(false)
      let userData = ref([])
      let allRecordTotal = ref(0)
      let allRecordPageSize = 10
      let allRecordPage = ref(1)
      let form = reactive(
              {
                phone:''
              }
      )
      function clearForm(){
        if(isEdit){
          let {province,city,zone,id} = currentRow
          form.province = province
          form.city = city
          form.zone = zone
          currentId = id
        }else{
          form.province = ''
          form.city = ''
          form.zone = ''
        }
      }
      function editDialog(row){//编辑
        outerVisible.value = true
        currentDealerId = row.id
        currentRow = row
        isEdit = true
        dialogTitle.value = '修改'
        clearForm()
      }
      function save(){//保存
        if(form.phone){
          let phones = form.phone.split(',')
          let params = {
            dealerId:currentDealerId,
            phones
          }
          bpDealerBindUser(params).then(res=>{
            ElMessage({
              message: '绑定成功',
              type: 'success'
            })
            outerVisible.value = false
          })
        }else{
          ElMessage({
            message: '请输入赋值人员手机号',
            type: 'error'
          })
        }
      }
      function handleSelectionChange(val){//多选
        delIds.value = []
        val.map(item=>{
          delIds.value.push(item.id)
        })
      }
      function onReset(){//重置
        query.dealerCode = ''
        query.dealerName = ''
        query.dealerPhone = '',
        query.dealerStatus = '',
        query.area = '',
        query.uphone = '',
        query.username = ''
      }
      function onSearch(){//搜索
        query.page = 1
      }
      function downloadTemplate(){//下载导入模板
        exportBpDealerTemplate().then(res=>{
          downloadFile(res,'经销商BP关系模板','xlsx')
        })
      }
      function importFile(){
        importloadLoading.value = true
      }
      function submit(file){
        let param = new FormData();
        param.append("file", file.raw);
        importBpDealer(param).then(res=>{
        })
      }
      function closeUploadDialog(){
        importloadLoading.value = false
      }
      function exportFile(){//导出
        let {zone,province,city} = query
        let params = {
          zone,
          province,
          city
        }
        exportDealerListByBpDealerVo(params).then(res=>{
          downloadFile(res,'经销商BP关系','xlsx')
        })
      }
      function _getBpStores(dealerId){
        let params = {
          dealerId
        }
        getBpStores(params).then(res=>{
          storeData.value = res.data
        })
      }
      function viewMoreStore(row){
        _getBpStores(row.id)
        storeVisiable.value = true
      }
      function _getAllbpDealerBindRecord(){
        let {dealerCode,dealerName,createBy,userName,userPhone,page,pageSize,operationStatus} = allRecordQuery
        let params = {
          page,
          pageSize,
          dealerCode,
          dealerName,
          createBy,
          userName,
          userPhone,
          operationStatus
        }
        getAllbpDealerBindRecord(params).then(res=>{
          allRecordData.value = res.data.pageData
          allRecordTotal.value = res.data.total
        })
      }
      function openRecordDialog(){
        _getAllbpDealerBindRecord()
        allRecordVisiable.value = true
      }
      function setHeaderStyle(){
        return {background:'#F2F5F9',color:'#001B4B'}
      }
      function _getBingUsers(row){
        let params = {
          dealerId:row.id
        }
        getBingUsers(params).then(res=>{
          userData.value = res.data
        })
      }
      function empowerUserDialog(row){
        _getBingUsers(row)
        empowerUserDialogVisiable.value = true
      }
      function unbind(row){
        let params = {
          dealerId:row.dealerId,
          userIds:[row.userId]
        }
        unBindBpDealer(params).then(res=>{
          _getBingUsers({id:row.dealerId})
        })
      }
      function changeRecordDialog(row){
        let params = {
          dealerId:row.id
        }
        getOneDealerRecord(params).then(res=>{
          oneRecordData.value = res.data
        })
        oneRecordVisiable.value = true
      }
      function changePageAllRecord(val){
        allRecordQuery.page = val
        _getAllbpDealerBindRecord()
      }
      function clearBind(){
        if(delIds.value.length>0){
          bpDealerClearBind(delIds.value).then(res=>{
            ElMessage({
              message: '解绑成功',
              type: 'success'
            })
          })
        }
      }
      function onAllRecordSearch(){
        allRecordQuery.page = 1
        _getAllbpDealerBindRecord()
      }
      function onAllRecordReset(){
        allRecordQuery.dealerCode = ''
        allRecordQuery.dealerName = ''
        allRecordQuery.createBy = ''
        allRecordQuery.userName = ''
        allRecordQuery.userPhone = ''
        allRecordQuery.operationStatus = ''
        allRecordQuery.page = 1
        _getAllbpDealerBindRecord()
      }
      function exportRecord(){
        let {dealerCode,dealerName,createBy,userName,userPhone,operationStatus} = allRecordQuery
        let params = {
          dealerCode,
          dealerName,
          createBy,
          userName,
          userPhone,
          operationStatus
        }
        exportDealerBindRecordListByBpDealerVo(params).then(res=>{
          downloadFile(res,'经销商BP变更记录','xlsx')
        })
      }
      onMounted(()=>{

      })
      return {
        dialogTitle,
        data,
        query,
        outerVisible,
        form,
        total,
        importloadLoading,
        dealerStatusList,
        oneRecordVisiable,
        oneRecordData,
        allRecordVisiable,
        allRecordData,
        storeVisiable,
        storeData,
        empowerUserDialogVisiable,
        userData,
        allRecordTotal,
        allRecordPageSize,
        allRecordPage,
        allRecordQuery,
        delIds,
        clearBind,
        save,
        editDialog,
        handleSelectionChange,
        onReset,
        onSearch,
        downloadTemplate,
        importFile,
        exportFile,
        submit,
        closeUploadDialog,
        clearForm,
        viewMoreStore,
        openRecordDialog,
        setHeaderStyle,
        empowerUserDialog,
        unbind,
        changeRecordDialog,
        changePageAllRecord,
        onAllRecordSearch,
        onAllRecordReset,
        exportRecord
      }
    }
  })

</script>
<style lang="scss" scoped>
  .demo-form-inline{
    .el-form-item{
      width: 20%;
    }
  }
  .el-dialog{
    .search-area{
      width:100%;
      display: flex;
      flex-wrap: wrap;
      .search-item{
        margin-bottom:15px;
        span{
          display: inline-block;
          width:100px;
          text-align: right;
        }
        .el-input{
          width:200px;
          margin-right: 15px;
        }
      }
    }
    .page-area{
      margin-top:20px;
      display: flex;
      justify-content: flex-end;
    }
  }

</style>
